export default function SectionWhyMean3() {
    const cards = [
        {
            title: "Proven Results",
            text: [
                "Our data-driven SEO strategies deliver measurable results, from higher rankings to increased traffic and sales."
            ]
        },
        {
            title: "Expert Team",
            text: [
                "Our in-house team of SEO experts stays ahead of industry trends and continuously optimizes for the latest algorithms."
            ]
        },
        {
            title: "Tailored Strategies",
            text: [
                "We understand the unique challenges of the UAE market and customize each strategy to fit your business needs."
            ]
        },
        {
            title: "Transparency",
            text: [
                "We keep you informed every step of the way, with detailed reports and regular strategy reviews."
            ]
        }
    ];

    return (
        <div className="w-full SectionWhyMean3">
            <div className="w-full section-container">
                {/* Section Heading */}
                <div className="w-[90%] md:w-[61%] text-center m-[24px_20px] md:mx-auto">
                    <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] my-[0.67em]">
                        Why Mean3 is the Best SEO Agency in{" "}
                        <span className="text-[#DA2128]">Dubai & Abu Dhabi</span>
                    </h2>
                    <p className="text-gray-600 text-sm md:text-base">
                        What Sets Us Apart
                    </p>
                </div>

                {/* Cards Grid */}
                <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            className={`${(index + 1) % 2 === 0
                                    ? "bg-[#f5f5f5] text-[#373737]"
                                    : "bg-[#E42E35] text-white"
                                } p-[10%] xs:p-[2%] xl:w-[26%] w-[90%] xs:w-[46%] rounded-lg shadow-lg`}
                        >
                            <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em] capitalize">
                                {card.title}
                            </h3>

                            <ul className="space-y-2 text-xs md:text-sm leading-[20px] font-open">
                                {card.text.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* Optional Divider */}
            <div className="line mb-[55px] mt-[1%] md:mt-[5%] md:mb-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
